var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yes-click-animation-wrapper"},[_c('div',{staticClass:"inner"}),_c('div',{staticClass:"dots-wrapper slide-up"},[_c('span',{staticClass:"dot"}),_c('span',{staticClass:"dot1"}),_c('span',{staticClass:"dot2"})]),_c('span',{staticClass:"checkmark draw"})])
}]

export { render, staticRenderFns }